import emUtils from "@/utils/emUtils";

export function customVuexEntityPatternFactory({
                                                   store: {state, actions, mutations}
                                                   , param: {
        entityState = "emCustomVuexEntity",
        entityConstructor = () => {
            return {}
        }
    }
                                               } = {}) {
    //添加state
    Object.assign(state, {[entityState]: Object.assign({}, new entityConstructor()),[`${entityState}Holder`]:{}})
    //转换首字母大写
    let entityStateCapFirst = emUtils.toCapFirst(entityState)
    //添加mutations
    Object.assign(mutations, {
        //整体设置
        [`set${entityStateCapFirst}`](state, data) {
            state[entityState] = data
        },
        //设置属性
        [`set${entityStateCapFirst}Attribute`](state, parameters) {
            state[entityState][parameters.key] = parameters.newValue;
        },
        //初始化
        [`clear${entityStateCapFirst}`](state) {
            state[entityState] = Object.assign({}, new entityConstructor())
        },
        //不带entityHolder
        [`setNew${entityStateCapFirst}WithoutHolder`](state) {
            //深拷贝
            // state[entityState] = JSON.parse(JSON.stringify(Object.assign(newEntityFunction(),state.entityHolder)))
            state[entityState] = Object.assign({}, new entityConstructor())
        },
        //默认是会带上entityHolder的
        [`setNew${entityStateCapFirst}`](state) {
            state[entityState] = JSON.parse(JSON.stringify(Object.assign(entityConstructor(), state[`${entityState}Holder`])))
        },
        [`set${entityStateCapFirst}Holder`](state,entityHolder) {
            state[`${entityState}Holder`] = entityHolder
        }
    })
}